<div class="card shadow-sm border-0">
  <div class="card-body">
    <h5 class="mb-3">Step 2 · Documents</h5>

    <div class="alert alert-light border" *ngIf="policyDocuments.length">
      Upload the required documents for this compliance policy.
    </div>

    <div class="alert alert-warning border" *ngIf="!policyDocuments.length">
      No policy document definitions were returned yet.
    </div>

    <div *ngIf="policyDocuments.length" class="mb-4">
      <h6 class="mb-3">Required Documents</h6>

      <div
        *ngFor="let policyDoc of policyDocuments; trackBy: trackByPolicyDoc"
        class="border rounded p-3 mb-2">
        <div class="d-flex justify-content-between align-items-start gap-2">
          <div>
            <div class="fw-semibold">{{ policyDoc.label || policyDoc.documentTypeCode }}</div>
            <div class="small text-muted">Code: {{ policyDoc.documentTypeCode }}</div>
            <div class="small text-muted">
              Min: {{ policyDoc.minFiles }} · Max: {{ policyDoc.maxFiles }}
            </div>
          </div>

          <div class="text-end">
            <span class="badge me-1"
              [ngClass]="policyDoc.isRequired ? 'text-bg-danger' : 'text-bg-secondary'">
              {{ policyDoc.isRequired ? 'Required' : 'Optional' }}
            </span>

            <span class="badge text-bg-light border">
              Uploaded: {{ getDocumentCount(policyDoc.documentTypeCode) }}
            </span>
          </div>
        </div>

        <div class="small text-muted mt-2" *ngIf="policyDoc.requiresExpiryDate">
          This document requires an expiry date.
        </div>
        <div class="small text-muted" *ngIf="policyDoc.requiresFrontAndBack">
          Front and back upload required.
        </div>
        <div class="small text-muted" *ngIf="policyDoc.requiresSelfieMatch">
          Selfie match required.
        </div>
      </div>
    </div>

    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <label class="form-label">Document Type</label>
        <select
          class="form-select"
          [ngModel]="draftDocumentTypeCode"
          (ngModelChange)="onDocumentTypeCodeChanged($event)">
          <option value="">Select document type</option>
          <option
            *ngFor="let doc of policyDocuments; trackBy: trackByPolicyDoc"
            [value]="doc.documentTypeCode">
            {{ doc.label || doc.documentTypeCode }}
          </option>
        </select>
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Expiry Date
          <span class="text-danger" *ngIf="selectedPolicyDocument?.requiresExpiryDate">*</span>
        </label>
      <input
        type="date"
        class="form-control"
        [ngModel]="draftExpiryDate"
        [attr.min]="getExpiryMinDate()"
        [required]="!!selectedPolicyDocument?.requiresExpiryDate"
        (ngModelChange)="onExpiryDateChanged($event)" />

      <div class="col-12">
        <label class="form-label">Choose File</label>
        <input
          type="file"
          class="form-control"
          (change)="onFileSelected($event)" />
      </div>
    </div>

    <div class="d-flex justify-content-end mb-4">
      <button
        class="btn btn-primary"
        [disabled]="uploadBusy || !canEdit"
        (click)="onUploadClicked()">
        <span *ngIf="uploadBusy" class="spinner-border spinner-border-sm me-2"></span>
        Upload Document
      </button>
    </div>

    <h6 class="mb-3">Uploaded Documents</h6>

    <div *ngIf="!uploadedDocuments.length" class="text-muted small">
      No documents uploaded yet.
    </div>

    <div
      *ngFor="let doc of uploadedDocuments; trackBy: trackByDoc"
      class="border rounded p-3 mb-2">
      <div class="d-flex justify-content-between align-items-start gap-2">
        <div>
          <div class="fw-semibold">{{ doc.label || doc.documentTypeCode }}</div>
          <div class="small text-muted">{{ doc.fileName }}</div>
          <div class="small text-muted">{{ doc.mimeType }}</div>
        </div>

        <span class="badge text-bg-secondary">
          {{ doc.status }}
        </span>
      </div>

      <div *ngIf="doc.expiryDate" class="small text-muted mt-2">
        Expiry: {{ doc.expiryDate | date:'mediumDate' }}
      </div>

      <div *ngIf="doc.rejectionReason" class="small text-danger mt-2">
        {{ doc.rejectionReason }}
      </div>

      <div class="mt-3 d-flex justify-content-end">
        <button
          class="btn btn-outline-danger btn-sm"
          [disabled]="deletingDocumentId === doc.id || !canEdit"
          (click)="onDeleteClicked(doc)">
          <span *ngIf="deletingDocumentId === doc.id" class="spinner-border spinner-border-sm me-2"></span>
          Delete
        </button>
      </div>
    </div>
  </div>
</div>